import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import UiButton from "../../Common/UiButton/UiButton";
import TextInput from "../../Common/UITextInput/TextInput";
import {
  getChangeSignatoryDetail,
  saveChangeSignatoryDetail,
} from "../../../redux/ChangeSignatory/action";
import { Form, Drawer, message } from "antd";
import { Col, Row } from "reactstrap";
import useForm from "../../../common/hooks/useForm";
import { LoadingOutlined } from "@ant-design/icons";
import { Spin, notification } from "antd";
import useSession from "../../CustomLogout/useSession";
import { getDocuments } from "../../../redux/Documents/Get/GetDocumentsAction";

const ChangeSignatory = ({
  setPartnerRefresh,
  partnerRefresh,
  drawerOpen,
  setDrawerOpen,
  ...props
}) => {
  const handleSessionExpired = useSession();

  const [form] = Form.useForm();

  const { onChangeTextHandler } = useForm();
  const FormItem = Form.Item;
  const [btnDisable, setBtnDisable] = useState(false);
  const [loading, setLoading] = useState(false);
  const [signatoryFullName, setSignatoryFullName] = useState("");
  const [signatoryEmail, setSignatoryEmail] = useState("");
  const [signatoryMobile, setSignatoryMobile] = useState("");
  const [saveLoading, setSaveLoading] = useState(false);

  const [open, setOpen] = useState(false);
  const showDrawer = () => {
    setOpen(true);
    setDrawerOpen(true);
  };
  const onClose = () => {
    setOpen(false);
    setDrawerOpen(false);
    form.resetFields();
  };

  // const signatoryFullName = props.row?.original?.signatoryFullName;
  // const signatoryEmail = props.row?.original?.signatoryEmail;
  // const signatoryMobile = props.row?.original?.signatoryMobile;

  useEffect(() => {
    if (drawerOpen && props.row?.original?.partnerFirmId) {
      setLoading(true);
      props
        .getChangeSignatoryDetail({
          access_token: props.access_token,
          partnerFirmId: props.row?.original?.partnerFirmId,
        })
        .then((res) => {
          setLoading(false);
          if (res && res.status === 200) {
            const data = res?.data?.dto;
            setSignatoryFullName(res?.data?.dto?.userFullName);
            setSignatoryEmail(res?.data?.dto?.emailAddress);
            setSignatoryMobile(res?.data?.dto?.mobileNo);

            form.setFieldsValue({
              userFirstName: data?.userFirstName,
              userLastName: data?.userLastName,
              emailAddress: data?.emailAddress,
              mobileNo: data?.mobileNo,
            });
          }
          if (res?.data?.error || res.message) {
            const errorCode = res?.data?.error?.errorCode || res.errorCode;
            const errorMessage = res?.data?.error?.message || res.message;

            if (errorCode === "403" && res?.data?.error?.logoutStatus) {
              setLoading(false);

              handleSessionExpired();
            } else {
              notification.error({
                description: errorMessage,
                duration: 5,
                placement: "top",
              });
            }
          }
        })
        .catch((e) => {
          setLoading(false);
        });
    }
  }, [drawerOpen, props.row?.original?.partnerFirmId]);

  const handleChange = (state) => {
    setSaveLoading(true);
    const data = {
      emailAddress: state.emailAddress,
      userFirstName: state.userFirstName,
      userLastName: state.userLastName,
      mobileNo: state.mobileNo,
      roleType: "PARTNER",
    };
    setBtnDisable(true);
    props
      .saveChangeSignatoryDetail({
        values: data,
        access_token: props.access_token,
        partnerFirmId: props.row?.original?.partnerFirmId,
      })
      .then((res) => {
        console.log(res);
        setSaveLoading(false);
        if (res && res.status === 200) {
          setBtnDisable(false);
          message.success("Change Signatory User Successfully ");
          onClose();
          setPartnerRefresh(true);
        }
        if (res?.data?.error || res.message) {
          const errorCode = res?.data?.error?.errorCode || res.errorCode;
          const errorMessage = res?.data?.error?.message || res.message;
          setBtnDisable(false);
          if (errorCode === "403" && res?.data?.error?.logoutStatus) {
            handleSessionExpired();
          } else {
            notification.error({
              description: errorMessage,
              duration: 5,
              placement: "top",
            });
          }
        }
      })
      .catch((res) => {
        setSaveLoading(false);
      });
  };

  return (
    <div className="addpartner-section">
      {/* <p
        style={{ cursor: "pointer", color: "#00b1b1" }}
        onClick={() => {
          showDrawer();
          props.hide && props.hide();
        }}
      >
        Change Signatory User
      </p> */}
      <Drawer
        title="Basic Drawer"
        placement="right"
        onClose={onClose}
        open={drawerOpen}
        className="add-partner-dow"
      >
        <Form
          autoComplete="off"
          form={form}
          className="changeSignatory-main"
          onFinish={handleChange}
        >
          <Row>
            <Col
              lg={12}
              xs={12}
              md={12}
              sm={12}
              className="add-content-partner"
            >
              <Col md={6} className="addpartnerheading">
                <h2 className="main-heading">Change Signatory User</h2>
                <div className="headre-line"></div>
              </Col>
              <Col md={6} className="btn-section">
                <h2 onClick={onClose} className="cancel-btn-add">
                  CANCEL
                </h2>
              </Col>
            </Col>
          </Row>
          <h4>CURRENT SIGNATORY</h4>
          <Row className="form-group">
            <Col md={5} className="signatory-label-group">
              <p className="label">SIGNATORY NAME</p>
              <p className="value name-sec">
                {" "}
                {loading ? "Loading..." : signatoryFullName}
              </p>
            </Col>
            <Col md={5} className="signatory-label-group">
              <p className="label">SIGNATORY EMAIL</p>
              <p className="value">{loading ? "Loading..." : signatoryEmail}</p>
            </Col>
          </Row>
          <Row className="form-group">
            <Col md={5} className="signatory-label-group">
              <p className="label">SIGNATORY MOBILE</p>
              <p className="value">
                {loading ? "Loading..." : signatoryMobile}
              </p>
            </Col>
          </Row>
          <h4>NEW SIGNATORY INFO</h4>

          <Row>
            <Col lg={12} xs={12} md={12} sm={12} className="add-fields-partner">
              <Col md={5}>
                <FormItem
                  name="userFirstName"
                  label="Signatory First Name"
                  rules={[
                    {
                      required: true,
                      message: "Please Enter Signatory First Name",
                    },
                  ]}
                >
                  <TextInput
                    type="text"
                    onInput={(e) => {
                      let inputValue = e.target.value;
                      inputValue = inputValue.replace(/[^A-Za-z ]/g, "");
                      inputValue = inputValue.trimStart();
                      if (inputValue.trim() == "") {
                        inputValue = inputValue.trim();
                      }

                      if (inputValue.trim() !== "") {
                        inputValue = inputValue.trimStart();
                      }
                      e.target.value = inputValue;
                      onChangeTextHandler(e);
                    }}
                    // onChange={onChangeTextHandler}
                  />
                </FormItem>
              </Col>
              <Col md={5} className="add-partner-sec-2 mob-cs-sec">
                <FormItem
                  name="userLastName"
                  label="Signatory Last Name"
                  colon={false}
                  rules={[
                    {
                      required: true,
                      message: "Please Enter Signatory Last Name",
                    },
                  ]}
                >
                  <TextInput
                    maxLength={75}
                    type="text"
                    onInput={(e) => {
                      let inputValue = e.target.value;
                      inputValue = inputValue.replace(/[^A-Za-z ]/g, "");
                      inputValue = inputValue.trimStart();
                      if (inputValue.trim() == "") {
                        inputValue = inputValue.trim();
                      }

                      if (inputValue.trim() !== "") {
                        inputValue = inputValue.trimStart();
                      }
                      e.target.value = inputValue;
                      onChangeTextHandler(e);
                    }}
                    // onChange={onChangeTextHandler}
                  />
                </FormItem>
              </Col>
            </Col>
          </Row>

          <Row>
            <Col
              lg={12}
              xs={12}
              md={12}
              sm={12}
              style={{ marginTop: "10px" }}
              className="add-fields-partner"
            >
              <Col md={7}>
                <FormItem
                  name="emailAddress"
                  label="Signatory Email"
                  colon={false}
                  rules={[
                    {
                      required: true,
                      message: "Please Enter Signatory Email",
                    },
                  ]}
                >
                  <TextInput
                    maxLength={255}
                    type="email"
                    validation={[
                      {
                        type: "email",
                        message: "Invalid Email!",
                      },
                    ]}
                    onChange={onChangeTextHandler}
                  />
                </FormItem>
              </Col>
              <Col md={5} className="add-partner-sec-2 mob-cs-sec">
                <FormItem
                  name="mobileNo"
                  label="Signatory Mobile Number"
                  colon={false}
                  rules={[
                    {
                      required: true,
                      message: "Please Enter Signatory Mobile Number",
                    },
                  ]}
                >
                  <TextInput
                    maxLength={10}
                    validation={[
                      // otp should be 4 digit
                      {
                        pattern: new RegExp("^[0-9]{10}$"),
                        message: "Invalid mobile Number",
                      },
                    ]}
                    onChange={onChangeTextHandler}
                    onInput={(e) => {
                      if (e.target.value.trim() == "") {
                        e.target.value = e.target.value.trim();
                      }

                      if (e.target.value.trim() !== "") {
                        e.target.value = new RegExp("^[0-9-+]*$").test(
                          e.target.value
                        )
                          ? e.target.value?.trimStart()
                          : e.target.value
                              ?.trimStart()
                              ?.substring(0, e.target.value.length - 1);
                      }
                    }}
                    type="tel"
                  />
                </FormItem>
              </Col>
            </Col>
          </Row>

          <Row>
            <Col
              lg={12}
              xs={12}
              md={12}
              sm={12}
              style={{ marginTop: "10px" }}
              className="add-fields-partner last-btn-sec-changes"
            >
              <Col md={12} className="d-flex justify-content-end">
                {saveLoading && (
                  <div className="pr-4 spanner">
                    <Spin
                      size="large"
                      className="pr-4"
                      indicator={
                        <LoadingOutlined style={{ color: "#00d8db" }} />
                      }
                    ></Spin>
                  </div>
                )}
                <UiButton
                  disabled={btnDisable}
                  type="submit"
                  title="CONFIRM"
                  className="primary-btn"
                />
              </Col>
            </Col>
          </Row>
        </Form>
      </Drawer>
    </div>
  );
};

const mapDispatchToProps = (dispatch) => {
  return {
    saveChangeSignatoryDetail: (data) =>
      dispatch(saveChangeSignatoryDetail(data)),
    getChangeSignatoryDetail: (data) =>
      dispatch(getChangeSignatoryDetail(data)),
  };
};

const mapStateToProps = (state) => {
  return {
    state: state && state.auth,
    access_token: state && state.auth && state.auth.idToken,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ChangeSignatory);
